import * as React from 'react';
import styled from '@emotion/styled';
import { controlBase, errorRing } from './_mixins';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

const Field = styled.textarea<{ $error?: boolean }>`
  ${({ theme }) => controlBase(theme)}
  height: auto;
  min-height: 80px;
  padding: 8px 12px;
  line-height: ${({ theme }) => theme.lineHeight.base};
  resize: vertical;
  ${({ theme, $error }) => $error && errorRing(theme)}
`;

/** Lumen multiline textarea. */
export function Textarea({ error, ...rest }: TextareaProps) {
  return <Field $error={error} {...rest} />;
}
